import * as baseAdapter from './baseAdapter';
import { ICustomerReq, ICustomerRes } from '@/interfaces/customer';

export const searchCustomer = async (req: ICustomerReq) => {
  const ret = await baseAdapter.post<ICustomerRes>(
    '/v1/misc/customer/inquiry',
    req
  );
  return ret;
};
